export default __webpack_public_path__ + "static/media/H-sign.504e65b0.svg";